import { Observable } from 'rxjs';

import { SupplementMaterialsRendererComponent } from 'editing-tool/src/app/shared/components/paper/steps/supplements/materials-renderer/supplement-materials-renderer.component';
import { FileResponse, RendererMetadata } from 'sc-common';
import { ApiPaperSupplementListItem } from 'sc-common/core/services/open-api/main-api-client';

export class PaperSupplementsRenderers {
    public static materialsRenderer(downloadFileExpr: (rowModel: ApiPaperSupplementListItem) => Observable<FileResponse>): RendererMetadata<SupplementMaterialsRendererComponent> {

        return {
            componentType: SupplementMaterialsRendererComponent,
            initializer: inst => {
                inst.downloadFileExpr = downloadFileExpr;
            }
        };
    }
};
